// extracted by mini-css-extract-plugin
export default {"list":"styles_list__95yyv","list__back":"styles_list__back__kTrky","list__lay":"styles_list__lay__KiEGF"};